import React, { useEffect, useState, useRef } from "react";
import { menuNew, bannerHealth } from "./Datamenu_inc";
import { motion } from "framer-motion";
import Loading from "../component/Loading";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";

export const DataAnimal = () => {
  const containerRef = useRef(null);
  const viewerInstance = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6; // จํานวนรายการต่อหน้า
  const totalPages = Math.ceil(bannerHealth.length / itemsPerPage);
  const maxPagesToShow = 5; // จำนวนหน้าที่แสดงใน pagination

  // คำนวณ index ของรายการที่แสดงในหน้าปัจจุบัน
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = bannerHealth.slice(indexOfFirstItem, indexOfLastItem);

  // ฟังก์ชันเปลี่ยนหน้า
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // สร้าง array ของหน้าที่จะแสดง
  const getPageNumbers = () => {
    const pages = [];
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };
  const Animal = menuNew?.[1]?.name || "ไม่มีข้อมูล";
  useEffect(() => {
    if (currentItems.length === 0) return; // รอจนกว่ามีข้อมูล
    localStorage.removeItem("selectedItem");

    const showImages = () => {
      setTimeout(() => {
        // รอให้ DOM อัปเดตก่อน
        if (containerRef.current && !viewerInstance.current) {
          viewerInstance.current = new Viewer(containerRef.current, {
            inline: false,
            navbar: false,
            title: false,
            toolbar: {
              zoomIn: 1,
              zoomOut: 1,
              oneToOne: 1,
              reset: 1,
              prev: 1,
              play: 0,
              next: 1,
              rotateLeft: 1,
              rotateRight: 1,
              flipHorizontal: 1,
              flipVertical: 1,
            },
          });
        }
      }, 300); // หน่วงเวลา 300ms ให้ DOM โหลดเสร็จ
    };

    showImages();
    return () => {
      if (viewerInstance.current) {
        viewerInstance.current.destroy();
        viewerInstance.current = null;
      }
    };
  }, [currentItems]); // ให้ useEffect รอจนกว่ามีข้อมูล

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col  gap-10 pt-20 lg:px-0 px-10 mb-10"
      >
        <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
          {Animal.split("").map((char, index) => (
            <motion.span
              key={index}
              custom={index}
              variants={{
                hidden: { opacity: 0, y: 10 },
                visible: (i) => ({
                  opacity: 1,
                  y: 0,
                  transition: { delay: i * 0.1, duration: 0.3 },
                }),
              }}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              {char}
            </motion.span>
          ))}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="px-10 pb-20"
      >
        <Loading data={currentItems}>
          <div
            ref={containerRef}
            className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3 "
          >
            {currentItems.map((item, index) => (
              <div key={item.id} className="relative group w-full h-[400px]">
                <img
                  src={item.img ? item.img : "/images/info/notImg.png"}
                  alt={`ความรู้เกี่ยวกับสัตว์เลี้ยง ${index + 1}`}
                  className="object-cover rounded-md shadow shadow-blue-300 w-full h-full"
                />
                <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center bg-black/50 h-0 group-hover:h-full transition-all duration-300 ease-in-out">
                  <div
                    onClick={() => {
                      // เรียกแสดงรูปภาพตาม Index
                      if (viewerInstance.current) {
                        console.log("go");
                        viewerInstance.current.view(index);
                      }
                    }}
                    className="bg-gray-400/50  text-gray-100 px-2 py-1 rounded-md shadow-lg text-[14px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
                  >
                    View image
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Loading>
        {/* Pagination Controls */}
        <div className="flex justify-start mt-4">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="mx-1 px-3 py-1 rounded bg-gray-200 disabled:opacity-50 text-[#0F4D81]"
          >
            <i className="fa fa-arrow-left"></i>
          </button>

          {currentPage > maxPagesToShow / 2 + 1 && (
            <>
              <button
                onClick={() => paginate(1)}
                className="mx-1 px-3 py-1 rounded bg-gray-200"
              >
                1
              </button>
              <span className="mx-1 px-3 py-1">...</span>
            </>
          )}

          {getPageNumbers().map((page) => (
            <button
              key={page}
              onClick={() => paginate(page)}
              className={`mx-1 px-3 py-1 rounded ${
                currentPage === page
                  ? "bg-[#0F4D81] text-white"
                  : "bg-gray-200 text-[#0F4D81]"
              }`}
            >
              {page}
            </button>
          ))}

          {currentPage < totalPages - maxPagesToShow / 2 && (
            <>
              <span className="mx-1 px-3 py-1">...</span>
              <button
                onClick={() => paginate(totalPages)}
                className="mx-1 px-3 py-1 rounded bg-gray-200 text-[#0F4D81]"
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="mx-1 px-3 py-1 rounded bg-gray-200 disabled:opacity-50 text-[#0F4D81]"
          >
            <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      </motion.div>
    </>
  );
};
